import React, { Component } from 'react';
import { Container, Form, FormGroup, Input, Button, Col, UncontrolledAlert } from 'reactstrap';

import './style.css';
import background from './../../images/background.jpg';
import { getGeneral } from '../../actions/modules_action/customizations';
import { API_URL } from './../../constants'; 
import { connect } from 'react-redux';

class ResetPassword extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            form: {
                password: '',
                confirmPassword: ''
            },
            logo_image: '',
            accessId: 1,
        };
        this.props.getGeneral(this.props.token, this.state.accessId);
    }

    handleChange = (event) => {
        let attribute = event.target.getAttribute('data-state');

        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [attribute]: event.target.value
            }
        });
    }

    handleMessage = () => {
        if(this.props.error !== '') {
            return (
                <Col>
                    <UncontrolledAlert className="text-left" color="danger">
                        <strong>Error:</strong> {this.props.error}
                    </UncontrolledAlert>
                </Col>
            );
        } else if(this.props.success !== '') {
            return (
                <Col>
                    <UncontrolledAlert className="text-left" color="success ">
                        <strong>Success:</strong> {this.props.success}
                    </UncontrolledAlert>
                </Col>
            );
        }
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.props.submit(this.state.form);
    }

    render = () => {

        if (
            Object.keys(this.props.GetGeneral).length > 0 &&
            'status' in this.props.GetGeneral
          ) {
            if (
              this.props.GetGeneral.status &&
              Object.keys(this.props.GetGeneral.data).length > 0
            ) {
              this.setState({
                ...this.state,
                logo_image: this.props.GetGeneral.data.logo_image,
              });
              this.props.getGeneral();
            }
        }

        return (
        <div id="reset-password-page" style={{ backgroundImage: `url(${background})` }}>
            <Container>
                <div className="form-heading text-center mt-5 mb-4">
                    <a href="/#/"><img src={`${API_URL}/${this.state.logo_image}`} alt="Logo" style={{width:'555px'}} /></a>
                </div>
                <div className="reset-password-form  text-center">
                    <Col>
                        <h1 className="display-4">Choose New Password</h1>
                        <p className="callout text-medium text-left">
                            Please choose your new password.
                        </p>
                    </Col>
                    {this.handleMessage()}
                    <Col>
                        <Form id="reset-password" onSubmit={this.handleSubmit}>
                            <FormGroup>
                                <Input
                                    type="password"
                                    data-state="password"
                                    className="form-control"
                                    placeholder="Password"
                                    value={this.state.form.password}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Input
                                    type="password"
                                    data-state="confirmPassword"
                                    className="form-control"
                                    placeholder="Confirm Password"
                                    value={this.state.form.confirmPassword}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <Button color="info">Reset Password</Button>
                        </Form>
                        <div className="card-footer mt-3 text-medium">
                            Back to <a href="/#/login">Login</a>
                        </div>
                    </Col>
                </div>
            </Container>
        </div>
        
    )};
}

const mapStateToProps = (state) => {
    return {
        GetGeneral: state.GetGeneral
    };
}

export default connect(mapStateToProps, {
    getGeneral
})(ResetPassword);
